// แถบแจ้งเหตุฉุกเฉิน — ขึ้นทุกหน้าให้คนที่มีบทบาทตอนเกิดเหตุ ตราบที่เหตุยังไม่ปิด
//
// server ส่งเหตุที่เปิดอยู่มาเฉพาะคนที่มีบทบาท (ครูหอพัก ฝ่ายปกครอง พยาบาล ผู้บริหาร)
// ครูทั้งโรงเรียนเห็นแถบแดงพร้อมกันคือความตื่นตระหนก ไม่ใช่การช่วย
// แถบวางด้านล่างจอเพราะหัวหน้าจอถูก Header ของแต่ละหน้ายึดไว้ และบนมือถือนิ้วโป้งกดถึง
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import io from 'socket.io-client';
import axiosInstance from '../services/axiosInterceptor';
import { getToken } from '../services/authorize';

const API = process.env.REACT_APP_API || 'http://localhost:3002/api';

export default function EmergencyBanner() {
  const [active, setActive] = useState(null);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const load = useCallback(() => {
    axiosInstance.get(`${API}/safety/status`)
      .then(({ data }) => setActive(data.active))
      .catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const socket = io(process.env.REACT_APP_SOCKET_URL, { auth: { token: getToken() } });
    socket.on('emergency:update', load);
    return () => socket.disconnect();
  }, [load]);

  // อยู่ในหน้านับยอดอยู่แล้วไม่ต้องบังรายชื่อ
  if (!active || pathname.startsWith('/safety/emergency')) return null;

  return (
    <button
      type="button"
      onClick={() => navigate('/safety/emergency')}
      className="btn btn-danger w-100 rounded-0 d-flex align-items-center justify-content-center gap-2 py-3 fw-semibold"
      style={{ position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 1080 }}
    >
      <i className="ri-alarm-warning-fill fs-4"></i>
      <span>
        เหตุฉุกเฉิน: {active.type_th} · {active.ev_title}
        {active.ev_assembly ? ` — จุดรวมพล ${active.ev_assembly}` : ''}
      </span>
      <span className="text-decoration-underline">เปิดหน้านับยอด</span>
    </button>
  );
}
